function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing8, fontSize11, sans, white, black, grey5, grey35, info40, confirmation10, danger40, warning10, blue10, green35, green5, red25, red5, yellow35, yellow15, lineHeight } from "@churchofjesuschrist/eden-style-constants";
const Container = styled.span.withConfig({
  componentId: "nwbta1-0"
})(["", ";border-radius:3px;font:normal normal 600 ", " / ", " ", ";display:inline-block;padding:1px ", ";vertical-align:middle;letter-spacing:0.05em;height:1.125rem;"], ({
  color
}) => {
  switch (color) {
    case "default":
      return `background-color: ${grey35}; color: ${white}`;

    case "greySoft":
      return `background-color: ${grey5}; color: ${black}`;

    case "info":
      return `background-color: ${info40}; color: ${white}`;

    case "success":
      return `background-color: ${confirmation10}; color: ${black}`;

    case "error":
      return `background-color: ${danger40}; color: ${white}`;

    case "warn":
      return `background-color: ${warning10}; color: ${black}`;

    case "blueLight":
      return `background-color: ${blue10}; color: ${black}`;

    case "green":
      return `background-color: ${green35}; color: ${white}`;

    case "greenLight":
      return `background-color: ${green5}; color: ${black}`;

    case "red":
      return `background-color: ${red25}; color: ${white}`;

    case "redLight":
      return `background-color: ${red5}; color: ${black}`;

    case "yellowOchre":
      return `background-color: ${yellow35}; color: ${white}`;

    case "yellowOrange":
      return `background-color: ${yellow15}; color: ${black}`;

    default:
      return null;
  }
}, fontSize11, lineHeight, sans, spacing8);

const Badge = ({
  children,
  color = "default",
  ...props
}) => /*#__PURE__*/React.createElement(Container, _extends({
  color: color
}, props), children);

export default Badge;
Badge.propTypes = {
  /** Content to render inside the Badge Component */
  children: PropTypes.node.isRequired,

  /** The color of the badge */
  color: PropTypes.oneOf(["default", "greySoft", "info", "success", "error", "warn", "blueLight", "green", "greenLight", "red", "redLight", "yellowOchre", "yellowOrange"])
};